import config from "./formal";

const global = {
  CopyRight:
    "Copyright @2020-2025 河南安洛云信息科技有限公司 技术服务：400 6379 003",
  Record: "备案号：豫ICP备17050318号",
};

export default Object.assign(global, config);
